const DotNav = require('../components/DotNav').DotNav;

new DotNav();

console.log('Hello integration page');
